var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"pa-0"},[(
      !_vm.pointType.imageSidePlacement && _vm.score.showScore && _vm.isPointtypeActivated
    )?_c('v-row',[_c('v-col',{staticClass:"pa-0 ma-0",style:(_vm.scoreText)},[_c('div',{style:(_vm.pointType.imageOnSide
            ? 'padding-left:3px;padding-right:3px'
            : 'padding-left:1px;padding-right:2px')},[(_vm.pointType.iconIsOn && !_vm.pointType.imageOnSide)?_c('img',{style:('float: left; width:' +
            _vm.pointType.iconWidth +
            'px;height:' +
            _vm.pointType.iconHeight +
            'px;'),attrs:{"src":_vm.pointType.image}}):_vm._e()]),_c('div',[_c('p',{staticClass:"pa-0 ma-0",domProps:{"innerHTML":_vm._s(
            _vm.$sanitize(
              _vm.score.beforeText + ' ' + _vm.scoreValue + ' ' + _vm.score.afterText,
              _vm.sanitizeArg
            )
          )}})]),_c('div',{style:(_vm.pointType.imageOnSide
            ? 'padding-left:3px;padding-right:3px'
            : 'padding-left:1px;padding-right:2px')},[(_vm.pointType.iconIsOn && _vm.pointType.imageOnSide)?_c('img',{style:('float: left; width:' +
            _vm.pointType.iconWidth +
            'px;height:' +
            _vm.pointType.iconHeight +
            'px;'),attrs:{"src":_vm.pointType.image}}):_vm._e()])])],1):(
      _vm.pointType.imageSidePlacement && _vm.score.showScore && _vm.isPointtypeActivated
    )?_c('v-row',[_c('v-col',{staticClass:"pa-0 ma-0",style:(_vm.scoreText)},[_c('div',[_c('p',{staticClass:"pa-0 ma-0",domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.score.beforeText + '  ', _vm.sanitizeArg))}})]),_c('div',{style:(!_vm.pointType.imageOnSide
            ? 'padding-left:3px;padding-right:3px'
            : 'padding-left:1px;padding-right:2px')},[(_vm.pointType.iconIsOn && !_vm.pointType.imageOnSide)?_c('img',{style:('float: left; width:' +
            _vm.pointType.iconWidth +
            'px;height:' +
            _vm.pointType.iconHeight +
            'px;'),attrs:{"src":_vm.pointType.image}}):_vm._e()]),_c('div',[_c('p',{staticClass:"pa-0 ma-0",domProps:{"innerHTML":_vm._s(_vm.$sanitize(' ' + _vm.scoreValue + ' ', _vm.sanitizeArg))}})]),_c('div',{style:(_vm.pointType.imageOnSide
            ? 'padding-left:3px;padding-right:3px'
            : 'padding-left:1px;padding-right:2px')},[(_vm.pointType.iconIsOn && _vm.pointType.imageOnSide)?_c('img',{style:('float: left; width:' +
            _vm.pointType.iconWidth +
            'px;height:' +
            _vm.pointType.iconHeight +
            'px;'),attrs:{"src":_vm.pointType.image}}):_vm._e()]),_c('div',[_c('p',{staticClass:"pa-0 ma-0",domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.score.afterText, _vm.sanitizeArg))}})])])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }